import { render, staticRenderFns } from "./productHome.vue?vue&type=template&id=fe8b359a&scoped=true&"
import script from "./productHome.vue?vue&type=script&lang=js&"
export * from "./productHome.vue?vue&type=script&lang=js&"
import style0 from "./productHome.vue?vue&type=style&index=0&id=fe8b359a&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8b359a",
  null
  
)

export default component.exports